import React, { ReactNode } from 'react';
import DialogCardCandidateInfo from './DialogCardCandidateInfo';
import DialogCardTestInfo from './DialogCardTestInfo';
import { useActionDialogContext } from '../Context/ActionDialogContext';
import DialogCardContainer from './DialogCardContainer';

interface DialogCardProps {
    icon: React.ReactNode;
    dialogTitle: ReactNode;
    dialogBody: ReactNode;
    dialogCardContainerClassName?: string;
}

function DialogCard({
    dialogTitle,
    dialogBody,
    icon,
    dialogCardContainerClassName,
}: DialogCardProps): React.JSX.Element {
    const { selectedCandidates, availableTestTypes, includeExperienceCriteria } = useActionDialogContext();
    const candidate = selectedCandidates[0];

    return (
        <div className="flex h-full flex-col justify-between gap-6">
            <div className="flex flex-col items-start gap-6">
                <DialogCardCandidateInfo name={candidate.name} email={candidate.candidateEmail} />
                <DialogCardTestInfo
                    aptitudeScore={candidate.aptitudePercentileScore}
                    emotionalIntelligenceScore={candidate.emotionalIntelligencePercentileScore}
                    personalityScore={candidate.personalityPercentileScore}
                    skillsScore={candidate.skillsPercentileScore}
                    talentScore={candidate.talentScore}
                    experienceCriteriaScore={candidate.experienceCriteriaScore}
                    testTypes={availableTestTypes}
                    includesExperienceCriteria={includeExperienceCriteria}
                />
            </div>
            <DialogCardContainer
                dialogTitle={dialogTitle}
                dialogBody={dialogBody}
                icon={icon}
                className={dialogCardContainerClassName}
            />
        </div>
    );
}

export default DialogCard;
